(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxWidgetsPanel', {
		bindings: {},
		controller: MxWidgetsPanelController,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-left-side-panel/mx-widgets-panel/mx-widgets-panel.html',
	});

	MxWidgetsPanelController.$inject = ['mx.SolutionBuilderAgent.WidgetsPanelService'];
	function MxWidgetsPanelController(widgetsPanelService) {
		var vm = this;
		vm.widgetsPanelService = widgetsPanelService;

		vm.$onInit = function () {};

		return vm;
	}
})();
